import { render, staticRenderFns } from "./seeStudents.vue?vue&type=template&id=797467b5&scoped=true&"
import script from "./seeStudents.vue?vue&type=script&lang=js&"
export * from "./seeStudents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797467b5",
  null
  
)

export default component.exports